import { render, staticRenderFns } from "./user_trash.vue?vue&type=template&id=2c3e4ff9&"
import script from "./user_trash.vue?vue&type=script&lang=js&"
export * from "./user_trash.vue?vue&type=script&lang=js&"
import style0 from "./user_trash.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue/rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports